import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdEdit, MdSearch } from "react-icons/md";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { taskId } = useParams();

  return (
    <Layout
      {...props}
      cloudScheduleElements={
        taskId && (
          <Fragment>
            <NavListSectionHeader>Task {taskId}</NavListSectionHeader>
            <NavLink end to={`/admin/platform/cloudschedule/${taskId}`}>
              <NavListItem icon={MdSearch}>View</NavListItem>
            </NavLink>
            <NavLink to={`/admin/platform/cloudschedule/${taskId}/edit`}>
              <NavListItem icon={MdEdit}>Edit</NavListItem>
            </NavLink>
          </Fragment>
        )
      }
    />
  );
}
